module.exports = __webpack_public_path__ + "img/club.30e53612.svg";